__turbopack_context__.v({
  "circle": "avatar-module__msEz3W__circle",
  "icon": "avatar-module__msEz3W__icon",
  "initials": "avatar-module__msEz3W__initials",
  "size128": "avatar-module__msEz3W__size128",
  "size24": "avatar-module__msEz3W__size24",
  "size32": "avatar-module__msEz3W__size32",
  "size48": "avatar-module__msEz3W__size48",
  "size64": "avatar-module__msEz3W__size64",
  "wrapper": "avatar-module__msEz3W__wrapper",
});
